import * as httpTool from '../http-tools'
import * as apiConst from '../api-const'
export default {
    monthLive (params) {
        return httpTool.fetchPost(apiConst.momEvaluationSheetUrl,params)
    },
    setMonthLive (params,files) {
        return httpTool.fetchPostFile(apiConst.setMomEvaluationSheetUrl,params,files)
    },
    babyList (params) {
        return httpTool.fetchPost(apiConst.babyListUrl,params)
    },
    otherFormList (params) {
        return httpTool.fetchPost(apiConst.otherFormListUrl,params)
    }
}


// WEBPACK FOOTER //
// ./src/service/api/repository/monthLive-api.js